module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-group"
  }, [(_vm.imageList && _vm.imageList.length === 1) ? _c('div', {
    on: {
      "click": function($event) {
        return _vm.albumView(_vm.imageList[0], _vm.imageList)
      }
    }
  }, [(_vm.imageList[0]) ? _c('img', {
    attrs: {
      "src": _vm.imageList[0] + '_middle'
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.imageList && _vm.imageList.length > 1) ? _c('div', _vm._l((_vm.imageList), function(item) {
    return _c('div', {
      staticClass: "image-group-item-container",
      style: (_vm.objStyle)
    }, [_c('div', {
      staticClass: "image-group-item",
      on: {
        "click": function($event) {
          return _vm.albumView(item, _vm.imageList)
        }
      }
    }, [(item) ? _c('img', {
      attrs: {
        "src": item + '_small'
      }
    }) : _vm._e()])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6304465e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-group/index.vue
// module id = 283
// module chunks = 107